export default "__VITE_ASSET__914d3c74__"